import { showAppToast } from '@/utils/appToast'

/**
 * App-wide lightweight toast helper (TG + browser).
 */
export function showAppNotification(options = {}) {
  const {
    message,
    type = 'info',
    duration = 1800,
    title,
    silent = false,
  } = options

  if (!message || silent) return

  showAppToast({
    message,
    type,
    duration,
    title,
  })
}
